module.exports = __webpack_public_path__ + "img/subtraction-8@3x.757e0ee0.png";